import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Card,
  Form,
  Row,
  Col,
  Spinner,
  ListGroup,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import ReactExport from "react-export-excel";

//redux
import {
  getQuestionFactor,
  getQuestionCompetency,
  getMetricByFactor,
  getMetricaCompetencia,
} from "../../redux/evaluacion_desempenio/EvaluationMonitor/actions";
import { useHistory } from "react-router-dom";

const ExcelDownload = (props) => {
  const [loarderFactor, setLoaderFactor] = useState(false);
  const [loarderCompetencia, setLoaderCompetencia] = useState(false);
  const [dataFactor, setDataFactor] = useState([]);
  const [dataCompetencia, setDataCompetencia] = useState([]);
  const [loarderMetricaCompetencia, setLoarderMetricaCompetencia] =
    useState(false);
  const [dataMetricaCompetencia, setDataMetricaCompetencia] = useState([]);
  const [loarderMetricaFactor, setLoarderMetricaFactor] = useState(false);
  const [dataMetricaFactor, setDataMetricaFactor] = useState([]);

  const dispatch = useDispatch();
  const history = useHistory();

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  useEffect(() => {
    if (props.idCompetencia && props.idFactor) {
      dispatch(
        getQuestionCompetency(
          { id: parseInt(props.idCompetencia) },
          setDataCompetencia,
          setLoaderCompetencia
        )
      );
      dispatch(
        getQuestionFactor(
          {
            id: parseInt(props.idFactor),
          },
          setDataFactor,
          setLoaderFactor
        )
      );
    }
  }, [props.idCompetencia, props.idFactor]);

  //   useEffect(() => {
  //     console.log("info de competencia", dataCompetencia);
  //     console.log("info de factor", dataFactor);
  //   }, [dataCompetencia, dataFactor]);

  useEffect(() => {
    if (props.idPeriodicidad) {
      dispatch(
        getMetricaCompetencia(
          {
            tipo_busqueda: "periodicidad_id",
            filter: parseInt(props.idPeriodicidad),
          },
          setDataMetricaCompetencia,
          setLoarderMetricaCompetencia
        )
      );
      dispatch(
        getMetricByFactor(
          {
            tipo_busqueda: "periodicidad_id",
            filter: parseInt(props.idPeriodicidad),
          },
          setDataMetricaFactor,
          setLoarderMetricaFactor
        )
      );
    }
  }, [props.idPeriodicidad]);

  return (
    <>
      {loarderCompetencia || loarderFactor ? (
        <Spinner
          className="mr-2"
          as="span"
          animation="border"
          size="sm"
          role="status"
          aria-hidden="true"
        />
      ) : (
        <ExcelFile
          element={
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip {...props}>Descargar excel</Tooltip>}
            >
              <Button
                disabled={
                  dataFactor.length === 0 && dataCompetencia.length === 0
                }
                size="sm"
                variant="link"
                type="button"
              >
                <i className="material-icons">download</i>
              </Button>
            </OverlayTrigger>
          }
        >
          {/* {dataCompetencia.length > 0 && (
            <> */}
          <ExcelSheet data={dataCompetencia} name="competencia">
            {/* <ExcelColumn
              label="idEvaluacion"
              value="id_evaluacion"
              cellstyle={(value, row, column, rowIndex, columnIndex) => {
                if (column.label === "idEvaluacion") {
                  return { display: "none" };
                }
              }}
            /> */}

            <ExcelColumn
              label="id competencia"
              value="idCompetencia"
              cellstyle={(value, row, column, rowIndex, columnIndex) => {
                if (
                  column.label === "id competencia" &&
                  value.value === "idCompetencia"
                ) {
                  return { display: "none" };
                }
              }}
            />
            <ExcelColumn label="competencia" value="nombreCompetencia" />
            <ExcelColumn label="pregunta" value="pregunta" />
            <ExcelColumn label="descripcion" value="descripcionCompetencia" />
            <ExcelColumn label="id clasificacion" value="idClasificacion" />
            <ExcelColumn label="id plantilla" value="idPlantilla" />
            {dataMetricaCompetencia.map((item) => (
              <ExcelColumn label={item.descripcion} value="" />
            ))}
          </ExcelSheet>
          {/* </>
          )} */}
          {/* {dataFactor.length > 0 && (
            <> */}
          <ExcelSheet data={dataFactor} name="factor">
            <ExcelColumn label="id evaluacion" value="encabezado_id" />
            <ExcelColumn label="periodicidad" value="periodicidad" />
            <ExcelColumn label="descripcion" value="descripcion" />
            <ExcelColumn label="id factor" value="id_factor" />
            <ExcelColumn label="tipo factor" value="tipo_factor" />
            <ExcelColumn label="factor" value="nombre_factor" />
            <ExcelColumn
              label="id origen pregunta"
              value="id_origen_pregunta"
            />
            <ExcelColumn label="pregunta" value="pregunta" />
            <ExcelColumn label="id plantilla" value="id_origen_pregunta" />
            {dataMetricaFactor.map((item) => (
              <ExcelColumn label={item.descripcion} value="" />
            ))}
          </ExcelSheet>
          {/* </>
          )} */}
        </ExcelFile>
      )}
    </>
  );
};

export default ExcelDownload;
